export default {
    name: "MultiSectionModal",

    data () {
        return {
            totalModalSections: 1,
            currentModalSection: 1,
            nextButtonText: "",
            finalButtonText: "Create",
            disableNextButton: false,
        };
    },

    mounted () {
        this.setNextButtonText();
    },

    watch: {
        currentModalSection () {
            this.setNextButtonText();
        },

        totalModalSections () {
            this.setNextButtonText();
        },
    },

    computed: {
        isOnLastSection () {
            return this.currentModalSection === this.totalModalSections;
        },

        showPreviousButton () {
            return this.currentModalSection > 1;
        },

        previousButtonText () {
            return this.currentModalSection === 1 ? "Cancel" : "Previous";
        },
    },

    methods: {
        // use this for v-show or v-if
        isCurrentSection (section) {
            return this.currentModalSection === section;
        },

        setNextButtonText () {
            this.nextButtonText = this.isOnLastSection ? this.finalButtonText : "Next";
        },

        gotoNextSection () {
            if (this.isOnLastSection) {
                this.emitFinalClick();
                return;
            }
            this.currentModalSection += 1;
        },

        gotoPreviousSection (close = false) {
            this.disableNextButton = false;
            if (close) {
                this.goToSpecificSection(1);
            }

            if (this.currentModalSection === 1) {
                this.$emit("close-modal");
                return;
            }
            this.currentModalSection -= 1;
        },

        goToSpecificSection (section) {
            this.currentModalSection = section;
        },

        emitFinalClick () {
            Bus.$emit("final-click");
        },
    },
};
